import React, { useState } from 'react';
import { FileText, Download, Eye, Upload, Filter } from 'lucide-react';

const ProcessFlowDiagrams = () => {
  const [selectedArea, setSelectedArea] = useState('all');

  const pfds = [
    {
      id: 1,
      name: 'Main Distillation Unit PFD',
      area: 'Distillation',
      documentNumber: 'PFD-001-2024',
      revision: 'Rev. 3',
      lastUpdated: '2025-11-20',
      status: 'Approved',
      fileSize: '2.4 MB',
      thumbnail: '/api/placeholder/300/200'
    },
    {
      id: 2,
      name: 'Reactor Section Process Flow',
      area: 'Reaction',
      documentNumber: 'PFD-002-2024',
      revision: 'Rev. 2',
      lastUpdated: '2025-10-15',
      status: 'Approved',
      fileSize: '1.8 MB',
      thumbnail: '/api/placeholder/300/200'
    },
    {
      id: 3,
      name: 'Cooling Water System PFD',
      area: 'Utilities',
      documentNumber: 'PFD-003-2024',
      revision: 'Rev. 1',
      lastUpdated: '2025-12-01',
      status: 'Under Review',
      fileSize: '1.2 MB',
      thumbnail: '/api/placeholder/300/200'
    },
    {
      id: 4,
      name: 'Steam Generation PFD',
      area: 'Utilities',
      documentNumber: 'PFD-004-2024',
      revision: 'Rev. 4',
      lastUpdated: '2025-09-28',
      status: 'Approved',
      fileSize: '3.1 MB',
      thumbnail: '/api/placeholder/300/200'
    }
  ];

  const areas = [
    { id: 'all', name: 'All Areas', count: pfds?.length },
    { id: 'distillation', name: 'Distillation', count: 1 },
    { id: 'reaction', name: 'Reaction', count: 1 },
    { id: 'utilities', name: 'Utilities', count: 2 }
  ];

  return (
    <div className="space-y-6">
      {/* Header Actions */}
      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
          <div className="flex flex-wrap gap-2">
            {areas?.map((area) => (
              <button
                key={area?.id}
                onClick={() => setSelectedArea(area?.id)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedArea === area?.id
                    ? 'bg-blue-600 text-white' :'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {area?.name} ({area?.count})
              </button>
            ))}
          </div>

          <div className="flex items-center space-x-2">
            <button className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50">
              <Filter className="w-5 h-5 text-gray-600" />
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium flex items-center space-x-2">
              <Upload className="w-4 h-4" />
              <span>Upload PFD</span>
            </button>
          </div>
        </div>
      </div>
      {/* PFDs Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {pfds?.map((pfd) => (
          <div key={pfd?.id} className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow overflow-hidden">
            {/* Thumbnail */}
            <div className="h-48 bg-gray-100 flex items-center justify-center">
              <FileText className="w-16 h-16 text-gray-400" />
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{pfd?.name}</h3>
                  <p className="text-sm text-gray-600">{pfd?.documentNumber}</p>
                </div>
                <span className={`px-2 py-1 text-xs font-medium rounded ${
                  pfd?.status === 'Approved' ?'bg-green-100 text-green-800' :'bg-yellow-100 text-yellow-800'
                }`}>
                  {pfd?.status}
                </span>
              </div>

              <div className="space-y-2 mb-4">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Area:</span>
                  <span className="font-medium text-gray-900">{pfd?.area}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Revision:</span>
                  <span className="font-medium text-gray-900">{pfd?.revision}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">File Size:</span>
                  <span className="font-medium text-gray-900">{pfd?.fileSize}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Last Updated:</span>
                  <span className="font-medium text-gray-900">{pfd?.lastUpdated}</span>
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center space-x-2 pt-4 border-t border-gray-200">
                <button className="flex-1 flex items-center justify-center space-x-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium">
                  <Eye className="w-4 h-4" />
                  <span>View</span>
                </button>
                <button className="flex-1 flex items-center justify-center space-x-1 px-3 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 text-sm font-medium">
                  <Download className="w-4 h-4" />
                  <span>Download</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessFlowDiagrams;